import * as types from '../config/actionTypes';

const SetupActions = {
	readData: (data) => ({ type: types.READ_SETUP, data }),
	updateId: (data) => ({ type: types.UPDATE_SETUP, data }),
	updateBiz: (data) => ({ type: types.UPDATE_SETUP_BIZ, data }),
	updateTech: (data) => ({ type: types.UPDATE_SETUP_TECH, data }),
	updateEmailSetup: (data) => ({ type: types.UPDATE_EMAIL_SETUP, data })
};

export default SetupActions;
